export const STATUS_OPTIONS = [
	"Pending",
	"Loaded",
	"Running",
	"Completed",
	"Cancelled",
];

export const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
	Pending: { bg: "#FFF3E0", color: "#E65100" },
	Loaded: { bg: "#E0F2F1", color: "#00695C" },
	Running: { bg: "#E3F2FD", color: "#1565C0" },
	Completed: { bg: "#E8F5E9", color: "#2E7D32" },
	Cancelled: { bg: "#FAFAFA", color: "#757575" },
};
